import styled from 'styled-components';
import BanquetHallIconSvg from '../../assets/hotels/amenities/banquet-hall.svg';

const BanquetHallIcon = styled(BanquetHallIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1.5rem'};
  height: ${props => props.height || '1.5rem'};
  fill: ${props => props.fill || props.theme.colors.grey.grey50};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default BanquetHallIcon;
